import React from 'react';
import { useSelector } from 'react-redux';

import { isEmpty } from 'lodash';

import { Tab } from '~/components';
import { CONTROLE_DE_COTAS } from '~/constants/modules';
import { t, can, canURL } from '~/helpers';

import { Cota, Dados } from './components';
import * as S from './styles';

export default function Tabs({ ...rest }) {
  const redux = useSelector((state) => state.empresaveiculo);

  const permission = canURL();

  const initials = rest.create ? rest.data : { ...redux.find, ...rest.data };

  const data = [
    {
      label: t('s.cadastro.empresaveiculo.dados'),
      content: (
        <Dados
          data={initials}
          create={rest.create}
          reference={rest.reference}
          toggleConfirmButton={rest.toggleConfirmButton}
        />
      ),
    },
  ];

  if (!isEmpty(initials) && can(CONTROLE_DE_COTAS)) {
    if (
      permission.post_cota === true ||
      permission.put_cota === true ||
      permission.delete_cot === true
    ) {
      data.push({
        label: t('s.cadastro.empresaveiculo.cota'),
        content: (
          <Cota
            active={initials}
            toggleConfirmButton={rest.toggleConfirmButton}
          />
        ),
      });
    }
  }

  return (
    <S.Container>
      <Tab items={data} />
    </S.Container>
  );
}
